export default __webpack_public_path__ + "static/media/6.cb1c2133.jpg";